import { Component, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Table } from 'primeng/table';
import { Subscription } from 'rxjs';
import { Modules, LocalStorage, SubMenues, MenuItems, MenuItemsAccess } from 'src/app/appCommon/Enums/enum';
import { AuthService } from 'src/app/appServices/AuthService/auth.service';
import { AccessControlService } from 'src/app/appServices/CommonService/access-control.service';
import { DefineService } from 'src/app/appServices/DefineService/define-service';
import { PiteamService } from 'src/app/appServices/DefineService/piTeam-service';
import { HelperService } from 'src/app/appServices/HelperService/helper.service';
import { allQualityGoal } from 'src/app/appWeb/shared/shared-interface';

@Component({
  selector: 'app-facilities',
  templateUrl: './facilities.component.html',
  styleUrls: ['./facilities.component.scss']
})
export class FacilitiesComponent implements OnInit {
  @ViewChild('dt') dt: Table | undefined;
  // qualityGoal: Array<allQualityGoal> = [];
  @Output() facilityBenchMarkGrid: any = [];
  QualityGoalsURL:string = '';
  @Output() totalRecords:number = 0;
  pageNumber:number = 1;
  rows: number = 15;
  sortOrder:string = "Asc";
  sortCol:string = "";
  filterVal:string = "";
  searchField:string = '';
  cols: any;
  showProgressSpinner: boolean = false;
  noRecordBool!: boolean;
  @Output() isAccessReadWrite: boolean = false;
  UId: any;
  RoleName: any;
  @Output() isAccessRead: boolean = false;
  editScreen: boolean = false;
  private subscription: Subscription[] = [];
  @Output() roleForFacility: boolean = false;
  crossSearchBool: boolean = false;

  constructor(private defineService: DefineService, private router: Router, private helperService: HelperService, public PiTeamService: PiteamService,
    private route: ActivatedRoute, private accessControlService: AccessControlService, private authService: AuthService ) {
    this.QualityGoalsURL = Modules.Layout + '/' + Modules.Define + '/' + SubMenues.QualityGoals;
  }

  ngOnInit(): void {
    this.UId = this.helperService.decryption(localStorage.getItem(LocalStorage.UId));
    this.RoleName = this.helperService.decryption(localStorage.getItem(LocalStorage.UserRoleName));
    this.roleForFacility = this.authService.roleForFacility();

    this.route.queryParamMap.subscribe((params:any) => {
      const getCase = params.get('getUserDetail');
      const getCaseDetail = Boolean(getCase);
      const edit = params.get('editScreen');
      this.editScreen = Boolean(edit);
      const FacilityID = params.get('FacilityID')
      const FacilityName = params.get('FacilityName')
      const screenStatus = params.get('screenStatus');
      
      if (getCaseDetail && screenStatus == 'Edit') {
        this.editFacility(FacilityID,FacilityName);
      }else if(getCaseDetail && screenStatus == 'View'){
        this.editFacility(FacilityID,FacilityName);
      }
      
    });
  }
  getAllFacilities() {
    var data = {

      Take: this.rows,
      Skip: (this.rows * this.pageNumber) - this.rows,
      Sort:
      {
        FieldName: this.sortCol,
        Order: this.sortOrder
      }
      ,
      Filter: {
        field: "",
        operator: "",
        value: this.searchField,
        logic: "",
        filters: []
      },
      searchString: this.searchField,
      PageNumber: this.pageNumber,
      serviceType: [],
      roleIDs: []
    }
    this.showProgressSpinner = true;

    var model = {
      request: data,
      roleName:this.RoleName,
      userId: this.UId,
      System: '',
      Facility: ''
    }
    this.subscription.push(
    this.defineService.GetAllFacilities(model).subscribe({
      next: (res: any) => {
        if (res.data.length == 0) { this.noRecordBool = true; }
        else { this.noRecordBool = false; }
        if (res.data) {
          this.facilityBenchMarkGrid = res.data;
          this.totalRecords = res.Total ? res.Total : 0;
          localStorage.setItem(LocalStorage.TotalFacilities, this.helperService.ecryption(this.totalRecords.toString()));
          this.showProgressSpinner = false;
        }
        this.PiTeamService.currentDateTime();


        const accessData = this.accessControlService.checkAccess( MenuItemsAccess.FBRead, MenuItemsAccess.FBReadWrite);
        this.isAccessRead = accessData.isAccessRead;
        this.isAccessReadWrite = accessData.isAccessReadWrite;
      },
      error: (err: any) => {
      },
    })
    );
  }
  editFacility(FacilityID: string, FacilityName: string) {
    localStorage.setItem(LocalStorage.FacilityID, this.helperService.ecryption(FacilityID));
    localStorage.setItem(LocalStorage.FacilityName, this.helperService.ecryption(FacilityName));
    this.defineService.PassingSearchFacility(this.searchField, false);
    this.router.navigate([this.QualityGoalsURL]);

  }
  async applyFilterGlobal($event: any, stringVal: string) {
    const inputValue = ($event.target as HTMLInputElement).value;
    this.dt = await this.defineService.getDtTable();
    this.dt!.filterGlobal(inputValue, stringVal);
    if(inputValue !== ''){
      this.crossSearchBool = true;
    }else{
    this.crossSearchBool = false;
    }
  }
  clearSearchField() {
    this.crossSearchBool = false;
    this.searchField = '';
    this.getAllFacilities();
   
  }
  lazyLoadSchedules(event: any) {
    if (event != undefined) {
      this.defineService.GetSearchFacility().pageTypeBool ? '' : this.defineService.PassingSearchFacility(this.searchField, false);
      this.rows = event.rows;
      this.pageNumber = (event.first / this.rows) + 1;
      this.sortOrder = (event.multiSortMeta == undefined || event.multiSortMeta[0].order == 1) ? 'ASC' : 'DESC';
      this.sortCol = (event.multiSortMeta == undefined) ? 'FacilityName' : event.multiSortMeta[0].field;
      this.filterVal = event.filters.global == undefined ? '' : event.filters.global.value;
      this.searchField = this.defineService.GetSearchFacility().passedFacility;
      this.searchField.length > 0 ? this.crossSearchBool =  true : this.crossSearchBool =  false;
      this.defineService.PassingSearchFacility(this.searchField, false);
      this.getAllFacilities();
    }
  }

  onContextMenu(event: { $event: MouseEvent; facilityId: string; facilityName: string; type: string }) {
    const { $event, facilityId, facilityName, type } = event;
    this.handleContextMenu($event, facilityId, facilityName, type);
  }

  handleContextMenu(event:MouseEvent,FacilityID: string, FacilityName: string,status:string){
    event.preventDefault();
    localStorage.setItem(LocalStorage.FacilityID, this.helperService.ecryption(FacilityID));
    localStorage.setItem(LocalStorage.FacilityName, this.helperService.ecryption(FacilityName));
    const queryParams = {
      getUserDetail: true,
      editScreen: true,
      FacilityID: FacilityID,
      FacilityName: FacilityName,
      screenStatus:status
    };
    const url = this.router.createUrlTree(['/Home/Define/FacilityBenchmarks'], { queryParams });
    window.open(url.toString(), '_blank');
  }

  onContextMenuPreventDefault(event:any){
    event.preventDefault();
  }
  
  ngOnDestroy() {
    if(this.subscription.length != 0){
      this.subscription.forEach((i:any)=>{
        i.unsubscribe();
      })
    }
    
    Object.getOwnPropertyNames(this)
    .filter(propName => Array.isArray((<any>this)[propName]))
    .forEach(propName => (<any>this)[propName] = []);
  }
}
